"use client";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { imageUrl } from "@/util/api/baseUrl";
import { ChangeDatePersian } from "@/util/tools";
import { getTimeAgo } from "@/util/tools/getTimeAgo";
import NoData from "@/util/view/NoData";
import { CommentsType } from "@/view/products/product";
import Image from "next/image";
import dynamic from "next/dynamic";
const AddComment = dynamic(() => import("./AddComment"), {
  ssr: false
})

const FavoriteComment = dynamic(() => import("./FavoriteComment"), {
  ssr: false
})

interface CommentListProps {
  data: CommentsType;
  productId: number
  productIId: number
}

const CommentList = ({ data, productIId, productId }: CommentListProps) => {
  return (
    <div className="sm:container">
      <AddComment productIId={productIId} productId={productId} />
      <div className="w-full p-1">
        {!data?.data?.rows.length ? (
          <NoData text="شما اولین دیدگاه را وارد کنید" />
        ) : (
          data?.data?.rows.map((i) => (
            <div key={i.id} className="m-2 bg-gray-100 border rounded">
              <div className="flex p-2 justify-between">
                <div className="flex items-center">
                  <p className="text-base font-bold text-salmon">
                    {i.comment_first_name + " " + i.comment_last_name}
                  </p>
                  <p className="text-sm border-ebony mr-2">
                    {getTimeAgo(i.createdAt)}
                  </p>
                </div>
                {i.comment_status === 1 ? (
                  ""
                ) : (
                  <p
                    className={`bg-orange-500 text-white rounded px-2 text-gray-100`}
                  >
                    تایید نشده
                  </p>
                )}
              </div>
              <Separator />
              <div className="p-2">
                {i.comment_description}
                <div className="flex justify-start">
                  {i.Albums.map((img) => {
                    return (
                      <div
                        key={img.id}
                        className="border rounded-lg p-[1px] m-1"
                      >
                        <div className="relative h-[50px] w-[50px] overflow-hidden">
                          <Image
                            src={`${imageUrl}${img.album_image_src}`}
                            alt=""
                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mOcvOVYPQAGfQKOiuBnlQAAAABJRU5ErkJggg=="
                            placeholder="blur"
                            priority
                            sizes="(max-width: 600px) 100vw, 50vw"
                            fill
                            className="object-cover rounded-md my-0 sm:my-1"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
                <Separator className="my-2" />
                <div className="flex justify-between items-center">
                  <FavoriteComment
                    id={i.id}
                    prodId={i.ProductId}
                    like={i.Favorites}
                    ProductIdentityId={i.ProductIdentityId}
                  />
                </div>
              </div>
              {i?.childComments?.map((b) => (
                <Card
                  key={b.id}
                  className={`m-2 bg-slate-300`}
                >
                  <div className="flex p-2 justify-between">
                    <p>{b.comment_first_name + " " + b.comment_last_name}</p>
                    <p>{ChangeDatePersian(b.createdAt)}</p>
                    {b.comment_status === 1 ? (
                      ""
                    ) : (
                      <p
                        className={`${b.comment_status === 1 ? "bg-lime-800" : "bg-ebony"
                          } rounded px-2 text-gray-100`}
                      >
                        تایید نشده
                      </p>
                    )}
                  </div>
                  <Separator />
                  <div className="p-2">
                    {b.comment_description}
                    <Separator className="my-2" />
                    <FavoriteComment
                      id={i.id}
                      prodId={i.ProductId}
                      like={i.Favorites}
                      ProductIdentityId={i.ProductIdentityId}
                    />
                  </div>
                </Card>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CommentList;
